<div *ngFor="let cl of classes" class="card mb-3">

    <div class="card-header">
        <span (click)="Filter(cl.name)">{{cl.name}}</span> <ng-container *ngIf="cl.parent"> - <small
                (click)="Filter(cl.parent)" class="fw-light fst-italic">{{cl.parent}}</small></ng-container>
    </div>
    <div class="card-body row ">


        <div class="col">
            <div>
                <h5>Level up Reward</h5>
                <app-attribute-store [attributes]="cl.levelup.attribute"></app-attribute-store>
            </div>


            <div>
                <strong>Free Attribute</strong>: {{cl.levelup.attribute_point}}
            </div>
        </div>
        <div class="col">
            <h5>Class Skills</h5>
            <ul>
                <li *ngFor="let skill of cl.skills">{{skill.name}}</li>
            </ul>
        </div>
    </div>
</div>